import * as Model from '../model.js';
import appView from './appView.js';
import * as Database from './database.js';
import previewView from './markups.js';
import {
  NOTE_TITLE_LIMIT,
  NOTE_DESCRIPTION_LIMIT,
  NOTESUCESS,
  FAILEDMESSAGE,
  SUCCESSUPDATE,
} from '../config.js';

class Notes extends appView {
  _parentElement = document.querySelector('.note-inbox');
  _listBtns = document.querySelectorAll('.list-actions');
  _addNoteBtn = document.querySelector('#btn-n-add');
  _containterItem = '.note-item';
  _message = 'Note was deleted successfully';
  _errorMsg = 'Empty Notes, Add a new Note!';
  _titleMaxLength = 100;
  _descriptionMaxLength = 500;

  constructor() {
    super();
    this.isEdit = false;
    this.noteId = null;
    this.favorited = null;
    this.newMarkup = true;
    this.initialize();
  }

  async initialize() {
    try {
      await this._setupEventListeners();
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  async _setupEventListeners() {
    await this.getAllItems();

    this._mobileMenu();
    this.toggleMenuViews();
    this._addNewNote();
    this._handlerAddButton();
  }

  async _deleteNote() {
    try {
      const deleteBtns = document.querySelectorAll('.delete-note');
      const self = this;
      deleteBtns.forEach(function (del) {
        del.addEventListener('click', function (e) {
          e.preventDefault();
          self.openModal('#noteDelete');
          $('.delete-note').on('click', function () {
            self.handleNoteDeletion(e);
          });
        });
      });
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  async handleNoteDeletion(e) {
    const note = e.target.closest('.note-item');
    const dataId = note.getAttribute('data-id');
    try {
      const request = await Database.deleteItemFromDatabase(dataId, 'notes');
      if (request) {
        note.remove();
        this.closeModal('#noteDelete', this._message, true);
      }
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    } finally {
      const storeLength = await Database.getObjectStoreLength('notes');
      if (storeLength === 0) this.renderErrorMessage();
      $('#noteDelete').modal('hide');
    }
  }

  _showNoteModal() {
    const notes = document.querySelectorAll('.note-content');
    const self = this;
    notes.forEach(note => {
      note.addEventListener('click', function (e) {
        e.preventDefault();
        const closestNoteContent = e.target.closest('.note-content');
        if (!closestNoteContent) return;

        const titleElement = closestNoteContent.querySelector('.note-title');
        const descriptionElement =
          closestNoteContent.querySelector('.note-description');

        const title = titleElement.getAttribute('data-notetitle');
        const description = descriptionElement.getAttribute(
          'data-notedescription'
        );
        self.showContentModal(title, description, '#NoteShowListItem');
      });
    });
  }

  async _favoriteNote() {
    const favBtns = document.querySelectorAll('.fav-note');
    const self = this;
    favBtns.forEach(function (fav) {
      fav.addEventListener('click', async function (e) {
        e.preventDefault();
        try {
          self.favoriteNote(e);
        } catch (err) {
          self.failedMessageInfo(FAILEDMESSAGE);
        }
      });
    });
  }

  async favoriteNote(e) {
    try {
      const note = e.target.closest('.note-item');
      const noteID = note.getAttribute('data-id');
      const favId = note.getAttribute('data-favorited');

      if (note) {
        const favoriteNote = await Database.updateItemInDatabase(
          noteID,
          'notes',
          {
            favorited: +favId === 0 ? 1 : 0,
          }
        );
        if (favoriteNote) {
          favId === '1'
            ? note.classList.remove('note-fav')
            : note.classList.add('note-fav');
          favId === '1'
            ? note.setAttribute('data-favorited', '0')
            : note.setAttribute('data-favorited', '1');
          this.successMessageInfo(SUCCESSUPDATE);
        }
      }
    } catch (err) {
      self.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  async _addLabelGroups() {
    const tagsSelect = document.querySelectorAll(
      '.tags-selector .label-group-item'
    );

    tagsSelect.forEach(tag => {
      tag.addEventListener(
        'click',
        async function (e) {
          e.preventDefault();
          const parentNoteItem = e.target.closest('.note-item');
          const getClass = tag.className;
          const getSplitclass = getClass.split(' ')[0];

          if (tag.classList.contains('label-personal')) {
            parentNoteItem.classList.remove(
              'note-social',
              'note-work',
              'note-important'
            );
            parentNoteItem.classList.toggle(getSplitclass);
          } else if (tag.classList.contains('label-work')) {
            parentNoteItem.classList.remove(
              'note-personal',
              'note-social',
              'note-important'
            );
            parentNoteItem.classList.toggle(getSplitclass);
          } else if (tag.classList.contains('label-social')) {
            parentNoteItem.classList.remove(
              'note-personal',
              'note-work',
              'note-important'
            );
            parentNoteItem.classList.toggle(getSplitclass);
          } else if (tag.classList.contains('label-important')) {
            parentNoteItem.classList.remove(
              'note-personal',
              'note-social',
              'note-work'
            );
            parentNoteItem.classList.toggle(getSplitclass);
          }

          const newTag = parentNoteItem.classList.contains(getSplitclass);
          const noteID = parentNoteItem.getAttribute('data-id');
          const newData = {
            tag: newTag ? getSplitclass : '',
          };

          try {
            await Database.updateItemInDatabase(noteID, 'notes', newData);
            this.successMessageInfo(SUCCESSUPDATE);
          } catch (error) {
            this.failedMessageInfo(FAILEDMESSAGE);
          }
        }.bind(this)
      );
    });
  }

  _mobileMenu() {
    const hamburger = document.querySelector('.hamburger');
    const appNoteOverlay = document.querySelector('.app-note-overlay');
    const tabLinks = document.querySelectorAll(
      '.tab-title .nav-pills a.nav-link'
    );
    const tabTitle = document.querySelector('.tab-title');
    if (hamburger) {
      hamburger.addEventListener(
        'click',
        function () {
          tabTitle.classList.toggle('note-menu-show');
          appNoteOverlay.classList.toggle('app-note-overlay-show');
        }.bind(this)
      );
    }
    if (appNoteOverlay) {
      appNoteOverlay.addEventListener(
        'click',
        function (e) {
          tabTitle.classList.remove('note-menu-show');
          appNoteOverlay.classList.remove('app-note-overlay-show');
        }.bind(this)
      );
    }

    if (tabLinks) {
      tabLinks.forEach(link => {
        link.addEventListener(
          'click',
          function (e) {
            tabTitle.classList.remove('note-menu-show');
            if (appNoteOverlay)
              appNoteOverlay.classList.remove('app-note-overlay-show');
          }.bind(this)
        );
      });
    }
  }

  _handlerAddButton() {
    const addBtn = document.querySelector('#btn-add-notes');

    if (addBtn) {
      const self = this;
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self._addNoteBtn.textContent = self.isEdit ? 'Save' : 'Add';
        const title = document.querySelector('#n-title');
        const description = document.querySelector('#n-description');
        self.openNoteModal('#notesMailModal', title, description);
      });
    }
  }

  setEditStateAndNoteId(noteId, favorited) {
    this.isEdit = true;
    this.noteId = noteId;
    this.favorited = +favorited;
    this.newMarkup = false;
  }

  resetEditStateAndNoteId() {
    this.isEdit = false;
    this.noteId = null;
    this.favorited = null;
    this.newMarkup = true;
  }

  _isEdit() {
    const editBtns = document.querySelectorAll('.edit-note');
    const self = this;
    editBtns.forEach(function (editbtn) {
      editbtn.addEventListener('click', function (e) {
        e.preventDefault();

        const noteId = e.target.closest('.note-item').getAttribute('data-id');
        const favorited = e.target
          .closest('.note-item')
          .getAttribute('data-favorited');

        self.setEditStateAndNoteId(noteId, favorited);
        self._addNoteBtn.textContent = self.isEdit ? 'Save' : 'Add';

        self.populateModalEdit(e);
        self._hideModalInfo();
      });
    });
  }

  populateModalEdit(e) {
    const note = e.target.closest('.note-item');
    const noteTitle = note
      .querySelector('.note-title')
      .getAttribute('data-notetitle');
    const noteDescription = note
      .querySelector('.note-description')
      .getAttribute('data-notedescription');
    const title = document.querySelector('#n-title');
    title.value = noteTitle;
    const description = document.querySelector('#n-description');
    description.value = noteDescription;
    this.openNoteModal('#notesMailModal', title, description);
  }

  _addNewNote() {
    if (this._addNoteBtn) {
      const self = this;

      this._addNoteBtn.addEventListener(
        'click',
        async function (e) {
          e.preventDefault();

          if (!this._validateNoteInput()) {
            return;
          }

          const data = self.isEdit
            ? Model.editNotes(self.noteId, self.favorited)
            : Model.createNotes();

          try {
            self.isEdit
              ? await Database.updateItemInDatabase(self.noteId, 'notes', data)
              : await Database.addItemtoDatabase(data, 'notes');

            await this.displayNotes(data, true);
            self.successMessageInfo(NOTESUCESS);
          } catch (err) {
            self.failedMessageInfo(FAILEDMESSAGE);
          } finally {
            $('#notesMailModal').modal('hide');
            this._hideModalInfo();
          }
        }.bind(this)
      );
    }
  }

  async displayNotes(data, newNote = false) {
    try {
      if (!data || (Array.isArray(data) && data.length === 0))
        return this.renderErrorMessage();

      if (newNote) {
        this.removeEmptyContainer();
        this.render(data);
      } else if (!newNote && !!this._parentElement) {
        for (const note of data) {
          await this.render(note);
        }
      }
    } catch (err) {
      self.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  async getAllItems() {
    try {
      const data = await Database.getAllItemsFromDatabase('notes');
      const sortedItems = this.sortDataByTimestamp(data);
      await this.displayNotes(sortedItems);
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  _generateMarkup(data, dataNew) {
    const newDate = this.formatDate(data.date, dataNew);

    const favorite = data.favorited === 1 ? 'note-fav' : '';
    const limitTitle = this.limitCharacters(data.title, NOTE_TITLE_LIMIT);
    const limitDescription = this.limitCharacters(
      data.description,
      NOTE_DESCRIPTION_LIMIT
    );
    const edited = data.isEdited ? 'Edited:' : '';

    const markup = previewView.notesMarkup(data, {
      newDate: newDate,
      favorite: favorite,
      limitTitle: limitTitle,
      limitDescription: limitDescription,
      edited: edited,
    });

    return markup;
  }

  async render(data, dataNew = true) {
    try {
      const containerElement = this._parentElement.querySelector(
        `.note-item[data-id="${data.id}"]`
      );

      const markup = this._generateMarkup(data, dataNew);

      if (!this.newMarkup) {
        this.update(data, markup, containerElement);
        this._renderFunctions();
        return;
      }

      // $('#ct').prepend(markup);
      // const parentEl = document.querySelector('.note-inbox');
      const element = this._parentElement.querySelector('.note-container');
      element.insertAdjacentHTML('afterbegin', markup);
      this._renderFunctions();
    } catch (err) {
      this.failedMessageInfo(FAILEDMESSAGE);
    }
  }

  _renderFunctions() {
    this._deleteNote();
    this._favoriteNote();
    this._showNoteModal();
    this._isEdit();
    this._addLabelGroups();
    const noteEl = document.querySelectorAll('.note-item');
    this._searchLists(noteEl);
  }

  _hideModalInfo() {
    const modal = document.getElementById('notesMailModal');
    const self = this;
    if (modal) {
      $(modal).on('hidden.bs.modal', function (event) {
        event.preventDefault();
        document.getElementById('n-title').value = '';
        document.getElementById('n-description').value = '';
        document.getElementById('n-tags').value = '';

        self.resetEditStateAndNoteId();
      });
    }
  }

  _validateNoteInput() {
    const getValidationField =
      document.getElementsByClassName('validation-text');
    const getNoteTitleInput = document.getElementById('n-title');
    const getNoteDescriptionInput = document.getElementById('n-description');

    const result = this.validateInput(
      getValidationField,
      getNoteTitleInput,
      getNoteDescriptionInput
    );

    return result;
  }
}

new Notes();
